import React from 'react'


const Hero = () => {
  
  return (
    <div className='hero-container scroll' id=" ">
        <div className="image-overlay"></div>
    </div>
  )
}

export default Hero